import { useCallback, useContext, useEffect, useRef, useState } from "react";
import TrackComponent from "../../components/TrackComponents/TrackComponent";
import { MyTrackProps, TrackObj } from "./types";
import {
  AuthContext,
  S3CredentialsContext,
  S3CredentialsContextInterface,
  UserDetailsContext,
} from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import RefreshIcon from "@mui/icons-material/Refresh";
import { UploadButton, styles } from "./styles";
import { ButtonContainer, ReloadButton } from "./styles";
import { Box, Grow, LinearProgress, Typography } from "@mui/material";
import { Track, GetTracksResponse } from "../../proto/api_pb";
import { TrackProcessorInfo } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import { fetchTracks, postTrack } from "../../services/trackService";
import { postBatchInitial } from "../../services/trackService";
import { convertToTrackObj } from "./utils";
import { TrackState } from "../../proto/api_pb";
import { toast } from "react-toastify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Files from "react-files";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
import StorageComponent from "../../components/StorageComponent/StorageComponent";
import { MyTrackControls } from "../../components/MyTrackComponents/MyTrackControls";
import { TrackMenuButton } from "../../components/TrackComponents/TrackMenuButton/TrackMenuButton";
import { CustomCircularProgress } from "../../components/ProgressComponents/CustomCircularProgress";
import Mixpanel from "../../utils/mixpanel";
import { MyTrackModalGroup } from "../../components/MyTrackComponents/MyTrackModalGroup";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { useSearchParams } from "react-router-dom";
import TagManager, { TagManagerArgs } from "react-gtm-module";
import ReactPixel from "react-facebook-pixel";
import {
  fetchBpmfromVersion,
  getPaymentMethod,
} from "../../components/TrackComponents/TrackHandler/trackHandlers";
import { OnboardingTutorial } from "../../components/OnboardingTutorial/OnboardingTutorial";
import { TrackTutorial } from "../../components/TrackTutorial/TrackTutorial";
const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;

const MyTracks: React.FC<MyTrackProps> = ({
  userVerified,
  getStorageUsed,
  setUploadingFilesDetailsList,
  setIsUploading,
  setUploadingCardsStatusList,
}) => {
  const [tracks, setTracks] = useState<TrackObj[]>([]);
  const [open, setOpen] = useState(false);
  const [openBatchModal, setOpenBatchModal] = useState(false);
  const [openAddVersionModal, setOpenAddVersionModal] = useState(false);
  const [openAddTrackFileModal, setOpenAddTrackFileModal] = useState(false);
  const { userId } = useContext(AuthContext);
  const [modal, setModal] = useState(false);
  const [trackToEdit, setTrackToEdit] = useState<Track>();
  const [trackToEditUrl, setTrackToEditUrl] = useState("");
  const [message, setMessage] = useState("");
  const [pageLoaded, setPageLoaded] = useState(false);
  const [state, setState] = useState<string>("Uploading music file...");
  const [previewState, setPreviewState] = useState<string>("");
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [trackToDeleteId, setTrackToDeleteId] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [currentUpload, setCurrentUpload] = useState("");
  const [openCollabsModal, setOpenCollabsModal] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState<TrackObj[]>([]);
  const fileUploadRef = useRef<HTMLInputElement>(null);
  const [progress, setProgress] = useState(0);
  const [currentGenres, setCurrentGenres] = useState<string[]>([]);
  const [bpmCache] = useState(new Map<string, number | undefined>());
  const [collaboratorsOptionsList, setCollaboratorsOptionsList] = useState<
    string[]
  >([]);
  const [flag, setFlag] = useState(0);
  const [hasPaymentMethod, setHasPaymentMethod] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [allArtistList, setAllArtistList] = useState<string[]>([]);
  const { userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);
  const toggle = () => {
    if (modal === true) {
      handleFetch();
      setModal(false);
    } else {
      setModal(true);
    }
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModalOpen(false);
  };
  const openDeleteConfirmModal = (id: string) => {
    Mixpanel.track("delete_track_open");
    setDeleteConfirmModalOpen(true);
    setTrackToDeleteId(id);
  };
  const { getValidAccessToken } = useGetValidAccessToken();

  const handleSelectedTracks = useCallback(() => {
    setSelectedTrack(tracks);
  }, [tracks]);

  // adding an incremental flag that resets tracks on clear filters
  // simply setting selectedTracks to tracks does not work
  useEffect(() => {
    setSelectedTrack([...tracks]);
    // eslint-disable-next-line
  }, [flag]);

  const getBpmFromTrackVersionId = useCallback(
    async (versionId: string) => {
      if (!bpmCache.get(versionId)) {
        const token = await getValidAccessToken();
        const responseBpm = await fetchBpmfromVersion(token, versionId);
        bpmCache.set(versionId, responseBpm);
      }
      return bpmCache.get(versionId);
    },
    [getValidAccessToken, bpmCache]
  );

  useEffect(() => {
    const tagManagerArgs: TagManagerArgs = {
      gtmId: "GTM-KBJ86GPC",
      dataLayer: {
        userId: userId,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    if (
      searchParams.get("plan") &&
      searchParams.get("plan")!.length > 0 &&
      (searchParams.get("plan") === "minor" ||
        searchParams.get("plan") === "major" ||
        searchParams.get("plan") === "studio")
    ) {
      if (process.env.REACT_APP_ENV === "production") {
        Mixpanel.track("pricing_table_success", {
          plan: searchParams.get("plan"),
        });
        const price =
          searchParams.get("plan") === "minor"
            ? 0
            : {
                value: searchParams.get("plan") === "major" ? 7.0 : 14.99,
              };
        const tagManagerArgs: TagManagerArgs = {
          gtmId: "GTM-KBJ86GPC",
          dataLayer: {
            event: "purchase",
            purchase: {
              value: price,
              currency: "USD",
              items: [
                {
                  item_name: "OmMuse Subscription",
                  item_variant: searchParams.get("plan"),
                  price: price,
                  quantity: 1,
                },
              ],
            },
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        ReactPixel.track("Purchase", {
          value: price,
          currency: "USD",
          items: [
            {
              item_name: "OmMuse Subscription",
              item_variant: searchParams.get("plan"),
              price: price,
              quantity: 1,
            },
          ],
        });
      }
    }
    setSearchParams({});
  }, [searchParams, setSearchParams, userId]);

  useEffect(() => {
    const allGenres: string[] = [];
    for (let i = 0; i < tracks.length; i++) {
      const genre = tracks[i].track?.getSongMetadata()?.getGenre();
      if (genre) allGenres.push(genre);
    }
    const uniqueSet = new Set(allGenres);
    const uniqueArray = Array.from(uniqueSet);
    setCurrentGenres(uniqueArray);
  }, [tracks]);

  useEffect(() => {
    handleSelectedTracks();
    document.title = "My OmMuse Hub";
    if (userId) getStorageUsed();
  }, [getStorageUsed, handleSelectedTracks, userId]);

  const stopAll = () => {
    tracks.forEach((track) => {
      if (track.waveSurfer?.isPlaying()) {
        track.waveSurfer?.stop();
      }
    });
  };

  const handleProgress = (pNum: number, idx: number, totalFiles: any[]) => {
    setProgress(pNum / totalFiles.length + idx * (100 / totalFiles.length));
  };

  const handleFileUpload = async (newFiles: any[]) => {
    setSubmitting(true);
    const files: any[] = [];
    newFiles.forEach((file) => {
      let found = false;
      for (let i = 0; i < files.length; i++) {
        if (
          file.name === files[i].name &&
          file.size === files[i].size &&
          file.extension === files[i].extension
        ) {
          found = true;
          break;
        }
      }
      if (!found) {
        files.push(file);
      }
    });

    const tracksProcessorInfoList: TrackProcessorInfo[] = [];
    for (let i = 0; i < files.length; i++) {
      setCurrentUpload(files[i].name);
      const songKey = await awaitableUploadToS3(
        userId,
        files[i],
        `song`,
        files[i].type,
        awsAccessKeyId,
        awsSecretAccessKey,
        awsSessionToken,
        (progress) => handleProgress(progress, i, files)
      );
      const songUrl = ASSETS_URL + "/" + songKey;
      const newTrack: TrackProcessorInfo = new TrackProcessorInfo();
      newTrack.setFilename(files[i].name);
      newTrack.setTrackUrl(songUrl);
      tracksProcessorInfoList.push(newTrack);
    }

    const postBatchTrackResponse = await postBatchInitial(
      tracksProcessorInfoList,
      userId,
      await getValidAccessToken()
    );
    if (postBatchTrackResponse instanceof RpcError) {
      throw postBatchTrackResponse;
    }
    // once api calls are done
    try {
      const response = (await fetchTracks(
        await getValidAccessToken(),
        userId
      )) as GetTracksResponse;
      //check that we don't get the deleted tracks
      const trackResponseList = response
        .getTracksList()
        .filter(
          (track) =>
            track.getTrack()?.getState() !== TrackState.TRACK_STATE_DELETED
        );
      const trackObjList = trackResponseList.map(convertToTrackObj);
      setTracks(trackObjList);
    } catch (e) {
      const error = e as RpcError;
      console.log(error.code);
      console.log(error.message);
    }
    setSubmitting(false);
  };

  const handleOpen = (id?: string) => {
    if (id) {
      Mixpanel.track("edit_track_open");
      const tr = tracks.filter((t) => t.track?.getId() === id)[0];
      setTrackToEdit(tr.track);
      setTrackToEditUrl(tr.trackUrl);
    }
    stopAll();
    updateIsPlayingStatus();
    setOpen(true);
  };

  const handleOpenCollabsModal = (id?: string) => {
    if (id) {
      Mixpanel.track("edit_track_collabs_open");
      const tr = tracks.filter((t) => t.track?.getId() === id)[0];
      setTrackToEdit(tr.track);
    }
    tracks.forEach((track) => {
      if (track.waveSurfer?.isPlaying()) {
        track.waveSurfer?.stop();
      }
    });
    updateIsPlayingStatus();
    setOpenCollabsModal(true);
  };

  const handleClearFilters = () => {
    setFlag((prev) => prev + 1);
  };

  const handleCloseCollabsModal = () => {
    setOpenCollabsModal(false);
  };

  const handleOpenVersionModal = (id?: string) => {
    if (id) {
      Mixpanel.track("add_track_version_open");
      const tr = tracks.filter((t) => t.track?.getId() === id)[0];
      setTrackToEdit(tr.track);
    }
    stopAll();
    updateIsPlayingStatus();
    setOpenAddVersionModal(true);
  };

  const handleOpenTrackFileModal = (id?: string) => {
    if (id) {
      Mixpanel.track("add_track_file_open");
      const tr = tracks.filter((t) => t.track?.getId() === id)[0];
      setTrackToEdit(tr.track);
    }
    stopAll();
    updateIsPlayingStatus();
    setOpenAddTrackFileModal(true);
  };

  const handleClose = (isSuccessful = false, statusMessage = "") => {
    if (isSuccessful === true) {
      toggle();
    }
    setMessage(statusMessage);
    setTrackToEdit(undefined);
    setOpen(false);
    setOpenBatchModal(false);
    setOpenAddVersionModal(false);
    setOpenAddTrackFileModal(false);
  };

  const handleOpenBatchModal = () => {
    Mixpanel.track("add_track_batch_upload_open");
    setOpenBatchModal(true);
  };

  const updateIsPlayingStatus = () => {
    setSelectedTrack((prevTracks) => {
      return prevTracks.map((track) => {
        return {
          ...track,
          isPlaying: track.waveSurfer?.isPlaying() ?? false,
        };
      });
    });
  };

  const getCurrentTrack = useCallback(
    (id: string) => tracks.find((item) => item.track?.getId() === id),
    [tracks]
  );

  const setAudioTrack = useCallback(
    (id: string, audioTrack: WaveSurfer) => {
      setTracks((prevTracks) => {
        return prevTracks.map((track) => {
          if (track.track?.getId() === id && !track.waveSurfer) {
            return {
              ...track,
              waveSurfer: audioTrack,
            };
          } else {
            return track;
          }
        });
      });
    },
    [setTracks]
  );
  const handlePlay = (id: string) => {
    Mixpanel.track("my_tracks_play");
    const song = getCurrentTrack(id)?.waveSurfer;
    const url = getCurrentTrack(id)?.trackUrl;
    if (song?.isReady) {
      song.playPause();
      if (song?.isPlaying()) {
        tracks
          .filter((item) => item.track?.getId() !== id)
          .forEach((track) => {
            if (track.waveSurfer?.isPlaying()) {
              track.waveSurfer?.stop();
            }
          });
      }
      updateIsPlayingStatus();
    } else {
      url !== undefined && song?.load(url);
      song?.empty();
      url !== undefined && song?.load(url);

      song?.on("ready", function () {
        song.playPause();
        if (song?.isPlaying()) {
          tracks
            .filter((item) => item.track?.getId() !== id)
            .forEach((track) => {
              if (track.waveSurfer?.isPlaying()) {
                track.waveSurfer?.stop();
              }
            });
        }
        updateIsPlayingStatus();
      });
    }
  };

  const handleStop = (id: string) => {
    const song = getCurrentTrack(id)?.waveSurfer;
    if (song) {
      song.stop();
      updateIsPlayingStatus();
    }
  };

  const handleFetch = useCallback(async () => {
    setPageLoaded(false);
    const token = await getValidAccessToken();
    try {
      const response = (await fetchTracks(token, userId)) as GetTracksResponse;
      const trackResponseList = response
        .getTracksList()
        .filter(
          (track) =>
            track.getTrack()?.getState() !== TrackState.TRACK_STATE_DELETED
        );
      const trackObjList = trackResponseList.map(convertToTrackObj);
      trackObjList.forEach((track) => {
        getBpmFromTrackVersionId(track!.track!.getTrackVersionId());
      });
      setTracks(trackObjList);
      setPageLoaded(true);
    } catch (e) {
      const error = e as RpcError;
      console.log(error.code);
      console.log(error.message);
    }
  }, [getValidAccessToken, getBpmFromTrackVersionId, userId]);

  useEffect(() => {
    if (userId !== "") {
      handleFetch();
    }
  }, [userId, getValidAccessToken, handleFetch]);

  const handleState = (state: string) => {
    setState(`${state}`);
  };

  const handlePreviewState = (state: string) => {
    setPreviewState(`${state}`);
  };

  const handleDeleteTrack = async () => {
    const foundTrack = tracks.find(
      (t) => t.track?.getId() === trackToDeleteId
    )?.track;
    if (foundTrack) {
      foundTrack.setState(TrackState.TRACK_STATE_DELETED);
      const newTrackList = tracks.filter(
        (t) => t.track?.getId() !== trackToDeleteId
      );
      setTracks([...newTrackList]);
      const postTrackResponse = await postTrack(
        foundTrack,
        await getValidAccessToken()
      );
      if (postTrackResponse instanceof RpcError) {
        //TODO: handle api exception gracefully with error modal, etc
        alert("Track was not deleted successfully");
        throw postTrackResponse;
      }
      Mixpanel.track("delete_track_success");
      toast.success("Track has been successfully removed");
    }
    closeDeleteConfirmModal();
  };
  const handleUserNames = useCallback(() => {
    const newArray: string[] = [];
    tracks.forEach((el) => {
      el.track?.getCollaboratorsList().forEach((item) => {
        newArray.push(item.getUsername());
      });
    });
    const uniqueArray = newArray.filter(
      (value, index) => newArray.indexOf(value) === index
    );
    const latestArray = uniqueArray.filter((item) => item !== userName);
    if (uniqueArray.length > 0) setCollaboratorsOptionsList(latestArray);
  }, [userName, tracks]);

  const handleArtistList = useCallback(() => {
    const newArray: string[] = [];
    tracks.forEach((el) => {
      if (el.track) newArray.push(el.track?.getArtist());
    });
    const uniqueArray = newArray.filter(
      (value, index) => newArray.indexOf(value) === index
    );
    setAllArtistList(uniqueArray);
  }, [tracks]);

  useEffect(() => {
    handleUserNames();
    handleArtistList();
  }, [handleUserNames, handleArtistList]);

  const handleUseEffect = useCallback(async () => {
    const token = await getValidAccessToken();
    const getMethod = await getPaymentMethod(token, userId);
    if (getMethod) setHasPaymentMethod(getMethod.getHasPaymentMethod());
  }, [getValidAccessToken, userId]);

  useEffect(() => {
    handleUseEffect();
  }, [handleUseEffect]);

  return (
    <>
      <OnboardingTutorial tracks={tracks} />
      <TrackTutorial tracks={tracks} />
      <MyTrackModalGroup
        handleFetch={handleFetch}
        pageLoaded={pageLoaded}
        modal={modal}
        toggle={toggle}
        message={message}
        deleteConfirmModalOpen={deleteConfirmModalOpen}
        closeDeleteConfirmModal={closeDeleteConfirmModal}
        handleDeleteTrack={handleDeleteTrack}
        openCollabsModal={openCollabsModal}
        handleCloseCollabsModal={handleCloseCollabsModal}
        trackToEdit={trackToEdit}
        open={open}
        handleClose={handleClose}
        trackToEditUrl={trackToEditUrl}
        openBatchModal={openBatchModal}
        openAddVersionModal={openAddVersionModal}
        openAddTrackFileModal={openAddTrackFileModal}
        setIsUploading={setIsUploading}
        setUploadingFilesDetailsList={setUploadingFilesDetailsList}
        setUploadingCardsStatusList={setUploadingCardsStatusList}
      />
      <Box style={styles.libraryContainer}>
        <Box style={styles.headerContainer}>
          <h1 style={styles.header}>My OmMuse Hub</h1>
        </Box>
        <>
          <ButtonContainer>
            <TrackMenuButton
              handleAddTrack={() => handleOpen()}
              handleAddTracks={() => handleOpenBatchModal()}
            ></TrackMenuButton>
            <ReloadButton onClick={() => handleFetch()}>
              <RefreshIcon />
            </ReloadButton>
            <StorageComponent />
          </ButtonContainer>
          <MyTrackControls
            tracks={tracks}
            setSelectedTrack={setSelectedTrack}
            collaboratorsOptionsList={collaboratorsOptionsList}
            allArtistList={allArtistList}
            selectedTrack={selectedTrack}
            currentGenres={currentGenres}
            bpmCache={bpmCache}
            handleClearFilters={handleClearFilters}
          />
        </>
        {pageLoaded && tracks.length === 0 && !submitting && (
          <Box sx={styles.noTrackContainer}>
            <Files
              forwardRef={fileUploadRef}
              className="image-upload"
              onError={(error: any, _: any) => {
                if (error.code === 1) {
                  toast.success("Invalid file format");
                }
              }}
              style={styles.fileUploadContainer}
              onChange={handleFileUpload}
              multiple
              maxFileSize={100000000}
              minFileSize={0}
              clickable
              accepts={["audio/*"]}
            >
              <Box>
                <Typography sx={styles.noTrackText}>
                  <span>There are no tracks in your library</span>
                  <br />
                  <br />
                  <span>Drop file(s) here or click to upload</span>
                </Typography>
              </Box>

              <UploadButton onClick={() => fileUploadRef.current?.click()}>
                Click to Upload
              </UploadButton>
            </Files>
          </Box>
        )}
        {submitting && (
          <Box sx={styles.submittingContainer}>
            <Typography sx={styles.uploading}>
              {currentUpload ? `Uploading ${currentUpload}` : `Uploading...`}
            </Typography>
            <CustomCircularProgress value={progress} />
          </Box>
        )}
        {!pageLoaded && (
          <Box style={styles.libraryContainer}>
            <Box sx={styles.linearProgressContainer}>
              <LinearProgress color="inherit" />
            </Box>
          </Box>
        )}
        {pageLoaded && selectedTrack.length > 0 && (
          // <Box label="box">
          <Grow in={true} style={{ transformOrigin: "top center" }}>
            <Box>
              {selectedTrack.map((item, index) => {
                return (
                  <TrackComponent
                    key={item.track?.getId()}
                    item={item}
                    setAudioTrack={setAudioTrack}
                    handlePlay={handlePlay}
                    handleStop={handleStop}
                    handleOpen={handleOpen}
                    versionId={item.track?.getId()}
                    handleState={handleState}
                    state={state}
                    handlePreviewState={handlePreviewState}
                    previewState={previewState}
                    openDeleteConfirmModal={openDeleteConfirmModal}
                    expand={false}
                    handleOpenVersionModal={handleOpenVersionModal}
                    userVerified={userVerified}
                    handleOpenCollabsModal={handleOpenCollabsModal}
                    handleOpenTrackFileModal={handleOpenTrackFileModal}
                    handleFetch={handleFetch}
                    stopAll={stopAll}
                    isTrackConnectedToTutorial={index === 0 ? true : false}
                    hasPaymentMethod={hasPaymentMethod}
                  />
                );
              })}
            </Box>
          </Grow>
        )}
      </Box>
    </>
  );
};

export default MyTracks;
